import { render, staticRenderFns } from "./HiaRichText.vue?vue&type=template&id=6d763d1a&scoped=true&"
import script from "./HiaRichText.vue?vue&type=script&lang=js&"
export * from "./HiaRichText.vue?vue&type=script&lang=js&"
import style0 from "./HiaRichText.vue?vue&type=style&index=0&id=6d763d1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d763d1a",
  null
  
)

export default component.exports